import {useEffect} from 'react';

import Button from 'components/Button/Button';
import Icon from 'components/Icon/Icon';
import Text from 'components/Text/Text';
import {useGlobalState} from 'hooks/useGlobalState';
import {useSetGlobalState} from 'hooks/useSetGlobalState';
import {setDeleteBeerConfirmationAC} from 'store/beers/beerSlice';
import {deleteBeerACS} from 'store/beers/requestAC';
import {setModalAC} from 'store/modal/modalSlice';
import './DeleteAdminBeerConfirmation.scss';

const DeleteAdminBeerConfirmation = () => {
  const {deleteBeerConfirmation} = useGlobalState((state) => state.beers);
  const dispatch = useSetGlobalState();

  const handleCancel = () => {
    dispatch(setModalAC(null));
  };

  const handleClick = () => {
    if (deleteBeerConfirmation) {
      dispatch(deleteBeerACS({id: deleteBeerConfirmation.id, name: deleteBeerConfirmation.name}));
      handleCancel();
    }
  };

  useEffect(() => {
    return () => {
      dispatch(setDeleteBeerConfirmationAC(null));
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="admin-delete-beer">
      <div className="admin-delete-beer__header">
        <Text tag="h4">DELETE beer</Text>
        <Button variant="empty" onClick={handleCancel}>
          <Icon icon="close" />
        </Button>
      </div>
      <Text className="admin-delete-beer__title" tag="h3">
        Are you sure you want to delete your beer?
      </Text>
      <div className="admin-delete-beer__actions">
        <Button variant="default" onClick={handleCancel}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleClick}>
          Delete
        </Button>
      </div>
    </div>
  );
};

export default DeleteAdminBeerConfirmation;
